import axiosInstance from '../Core/RestHelper';
import { Site } from '../Model/Site';

export class SiteService {
    static async getAllSites(): Promise<Site[]> {
        try {
          const response = await axiosInstance.get('/deploy/deployments');
          return response.data;
        } catch (error) {
          throw new Error('Failed to get GitHub auth URL');
        }
      }
}